module.exports = __webpack_public_path__ + "static/media/church.b8ca0788.svg";